import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isOpenMenu: false,
    isPagePDPA: false
  },
  getters: {
  },
  mutations: {
    setIsOpenMenu (state) {
      state.isOpenMenu = !state.isOpenMenu
    },
    setIsPagePDPA (state, payload) {
      state.isPagePDPA = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
